import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";

import { InboundDeliveriesQuery } from "../../../graphql/deliveryService/queries/inboundDeliveries";
import { InboundDeliveryOverviewPagedFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";

interface InboundDeliveriesQueryProps {
  dataAction: (data: InboundDeliveryOverviewPagedFragment) => void;
  errorAction?: () => void;
}

const useInboundDeliveriesQuery = (props: InboundDeliveriesQueryProps) => {
  const { dataAction } = props;

  const query = useLazyQuery(InboundDeliveriesQuery, {
    notifyOnNetworkStatusChange: true,
    //fetchPolicy: "network-only",
    nextFetchPolicy: "network-only",
  });

  const { data } = query[1];

  const inboundDeliveriesPagedFragment = data?.inboundDeliveries;

  useEffect(() => {
    if (!data || !inboundDeliveriesPagedFragment) return;

    dataAction(inboundDeliveriesPagedFragment);
  }, [data]);

  return query;
};

export default useInboundDeliveriesQuery;
